import { Typography } from '@mui/material';
import { IconMessage, IconSearch, IconSend } from '@tabler/icons-react';
import {
  VeltCommentBubbleWireframe,
  VeltCommentDialogWireframe,
  VeltComments,
  VeltCommentsSidebarWireframe,
  VeltCommentToolWireframe,
  VeltData,
  VeltIf,
  VeltWireframe,
  useIdentify,
} from '@veltdev/react';
import { useSelector } from 'store';
import {
  useGetUserNotificationAuthV2Query,
  useGetUserQuery,
} from 'store/slices/apiV1/user';
import SegmentIconButton from 'ui-component/Segment/SegmentIconButton';

const VeltWireframes = () => {
  const { data: user } = useGetUserQuery();
  const { activeOrgId } = useSelector((state) => state.org);

  const { data: veltAuth } = useGetUserNotificationAuthV2Query();

  const veltToken = veltAuth?.token;

  const veltUser = {
    userId: `${activeOrgId}_${user?.id}`,
    organizationId: activeOrgId || undefined,
    name: `${user?.firstName} ${user?.lastName}`,
    email: user?.email,
    photoUrl: user?.image || undefined,
  };

  useIdentify(veltUser, {
    authToken: veltToken,
  });

  return (
    <>
      <VeltComments
        recordings="none"
        popoverMode
        textMode={false}
        attachments={false}
        enterKeyToSubmit
        popoverTriangleComponent={false}
        draftMode={false}
        customReactions={{
          checkMarkButton: {
            emoji: '✅',
          },
          eyes: {
            emoji: '👀',
          },
          thumbsUp: {
            emoji: '👍',
          },
          thumbsDown: {
            emoji: '👎',
          },
          oneHundredPoints: {
            emoji: '💯',
          },
          plus: {
            emoji: '➕',
          },
          partyPopper: {
            emoji: '🎉',
          },
          raisingHands: {
            emoji: '🙌',
          },
        }}
      />
      <VeltWireframe>
        {/* Comment Composer Submit Button */}
        <VeltCommentDialogWireframe.Composer.ActionButton type="submit">
          <SegmentIconButton color="success" tooltip="Send">
            <IconSend />
          </SegmentIconButton>
        </VeltCommentDialogWireframe.Composer.ActionButton>
        {/* Comment Options */}
        <VeltCommentDialogWireframe.Options.Content>
          <VeltCommentDialogWireframe.Options.Content.Assign />
          <VeltCommentDialogWireframe.Options.Content.Edit />
          <VeltCommentDialogWireframe.Options.Content.Delete />
          <VeltCommentDialogWireframe.Options.Content.Notification />
        </VeltCommentDialogWireframe.Options.Content>
        {/* Comment Block */}
        <VeltCommentDialogWireframe>
          {/*  Assignee Banner - Only shown for assigned comments */}
          <VeltCommentDialogWireframe.AssigneeBanner />
          {/* Annotation Context */}

          <VeltIf condition="{sidebarMode}">
            <Typography variant="caption">
              <VeltData field="commentAnnotation.context.rowDescription" />
            </Typography>
          </VeltIf>
          {/* Body */}
          <VeltCommentDialogWireframe.Body />
          {/* Composer */}
          <VeltCommentDialogWireframe.Composer />
          {/* All Comments */}
          <VeltCommentDialogWireframe.AllComment />
          {/* Suggestion Action - Only when suggestion mode is on */}
          <VeltCommentDialogWireframe.SuggestionAction />
        </VeltCommentDialogWireframe>
        {/* Comment Sidebar */}
        <VeltCommentsSidebarWireframe.Header>
          <VeltCommentsSidebarWireframe.CloseButton />{' '}
          {/* Not shown for embedded comments sidebar */}
          <div className="search-icon">
            <IconSearch />
          </div>
          <VeltCommentsSidebarWireframe.Search placeholder="Search Comments..." />
        </VeltCommentsSidebarWireframe.Header>
        {/* Comment Inline */}
        <VeltCommentBubbleWireframe>
          <button
            type="button"
            className="flex items-center justify-center w-8 h-8 transition-colors velt-comment-bubble-customized"
            aria-label="View comments"
          >
            <VeltIf
              condition="{commentAnnotation.comments.length} > 0"
              className="velt-comment-if-customized"
            >
              <div>
                <VeltCommentBubbleWireframe.CommentsCount />
                <IconMessage className="w-5 h-5" />
              </div>
            </VeltIf>

            <VeltIf
              condition="{commentAnnotation.comments.length} === 0"
              className="velt-comment-if-customized"
            >
              <IconMessage className="w-5 h-5" />
            </VeltIf>
          </button>
        </VeltCommentBubbleWireframe>
        <VeltCommentToolWireframe>
          <button
            type="button"
            className="flex items-center justify-center w-8 h-8 transition-colors velt-comment-bubble-customized"
            aria-label="Add comment"
          >
            <IconMessage className="w-5 h-5" />
          </button>
        </VeltCommentToolWireframe>
      </VeltWireframe>
    </>
  );
};

export default VeltWireframes;
